import axios from "axios";
import { SERVER_URL } from "../../config/env";

const API_REGISTERURL = SERVER_URL + "auth/sign-up";
const API_VERIFICATIONURL = SERVER_URL + "auth/verify";

class AuthService {
  async verifyUser(id, code) {
    try {
      const response = await axios.post(API_VERIFICATIONURL, {
        id,
        token: code,
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async login(username, password) {
    try {
      const response = await axios.post(
        SERVER_URL + "login",
        {
          email: username,
          password: password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.token) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response; // ✔ wichtig: ganze response zurückgeben
    } catch (error) {
      throw error; // ✔ nicht return error
    }
  }

  async register(registerUser) {
    try {
      const response = await axios.post(API_REGISTERURL, registerUser);

      return response; // 👉 wichtig: komplette Response zurückgeben
    } catch (error) {
      throw error; // 👉 entscheidend: nicht zurückgeben
    }
  }

  clearStorage() {
    localStorage.removeItem("user");
    localStorage.removeItem("_expiredTime");
    localStorage.removeItem("_rerenderTime");
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  editCurrentUser(editedUser) {
    localStorage.setItem("user", JSON.stringify(editedUser));
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;
